import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import '../styles/About.css';

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
};

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.2 } },
};

export default function About() {
  return (
    <>
      <section className="flap-about">
        <div className="flap-about-inner">
          {/* Hero */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
          >
            <motion.span className="about-label" variants={fadeInUp}>
              About Flap
            </motion.span>

            <motion.h1 className="about-heading" variants={fadeInUp}>
              The Future of <em>Networking</em> is Here
            </motion.h1>

            <motion.p
              variants={fadeInUp}
              className="about-subtext"
            >
              Flap replaces outdated paper business cards with elegant, always-updated digital profiles. Tap once — share everything instantly. Update once — everyone sees the latest version. Simple. Modern. Forever.
            </motion.p>
          </motion.div>

          {/* Features Grid */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
            className="about-grid"
          >
            {[
              {
                icon: "⚡",
                title: "Instant Connection",
                text: "One tap shares your full profile — contacts, socials, links, photos, and more — with anyone, anywhere.",
              },
              {
                icon: "🔄",
                title: "Always Current",
                text: "Change your number, job, or social links once — every Flap instantly shows the latest information.",
              },
              {
                icon: "🎨",
                title: "Fully Customizable",
                text: "Choose colors, layout, theme, and add custom fields to make your digital identity truly unique.",
              },
            ].map((item, i) => (
              <motion.div key={i} variants={fadeInUp} className="about-card">
                <div className="about-icon">{item.icon}</div>
                <h3 className="about-title">{item.title}</h3>
                <p className="about-text">{item.text}</p>
              </motion.div>
            ))}
          </motion.div>

          {/* CTA inside About */}
          {/* <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="about-cta"
          >
            <a href="/register" className="about-cta-btn">
              Get Your Flap Today
            </a>
          </motion.div> */}
        </div>
      </section>

      {/* ── CTA Section ── */}
      <section className="flap-cta">
        <h2 className="reveal">
          Ready to go <strong>paperless</strong>?
        </h2>
        <p className="reveal">
          Join thousands of professionals across Nepal already using Flap.
        </p>
        <div className="cta-btn-group reveal">
          <Link to="/register" className="hero-btn-primary">
            Create Free Account →
          </Link>
          <a href="#how" className="hero-btn-secondary">
            See How It Works
          </a>
        </div>
      </section>
    </>
  );
}
